// Shared config for the link out to the frameworks platform.
//
// Frameworks runs on its own origin (Firebase Hosting site
// `numetrics-frameworks`) but against the same `numetrics-cte` Firebase
// project, so accounts are shared. Auth sessions are NOT: Firebase persists
// auth per origin, so arriving there is a fresh sign-in. That app's dashboard
// guard bounces signed-out visitors to /login?from=<path> and replays the
// destination afterward, so deep links degrade gracefully.
//
// Trailing slash is deliberate — the frameworks app builds with
// `trailingSlash: true`, so this URL answers 200 with no redirect hop.
export const FRAMEWORKS_URL = 'https://frameworks.numetrics.org/frameworks/';

// The launch banner removes itself on this date whether or not anyone has
// touched the code. Bump the key (not just the date) to announce something
// new later — a fresh key re-shows the banner to people who dismissed the
// previous one.
export const FRAMEWORKS_BANNER_EXPIRES = '2026-09-02';
export const FRAMEWORKS_BANNER_KEY = 'ctelink.frameworksBanner.v1.dismissed';

/**
 * Whether the launch banner should still be shown.
 *
 * Hidden once dismissed, and hard-stopped after the expiry date so it can't
 * become permanent furniture. Any localStorage failure (Safari private mode,
 * blocked storage) falls through to showing the banner rather than throwing.
 */
export function shouldShowFrameworksBanner(now = new Date()) {
  // Compare on date only; the expiry is a calendar day, not an instant.
  // Built from local parts rather than toISOString(), which is UTC and would
  // retire the banner a day early for anyone west of Greenwich.
  const today = [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, '0'),
    String(now.getDate()).padStart(2, '0'),
  ].join('-');
  if (today >= FRAMEWORKS_BANNER_EXPIRES) return false;

  try {
    return window.localStorage.getItem(FRAMEWORKS_BANNER_KEY) !== 'true';
  } catch {
    return true;
  }
}

export function dismissFrameworksBanner() {
  try {
    window.localStorage.setItem(FRAMEWORKS_BANNER_KEY, 'true');
  } catch {
    // Non-fatal: the banner stays dismissed for this page view either way.
  }
}
